/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderXIcon24Solid = forwardRef('FolderXIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a2 2 0 0 1 2-2h4.868a2 2 0 0 1 1.715.971l.399.665a.75.75 0 0 0 .643.364H18a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V5Zm13.688 5.726a1 1 0 0 0-1.414-1.414L12 11.586 9.726 9.312a1 1 0 1 0-1.414 1.414L10.586 13l-2.274 2.274a1 1 0 1 0 1.414 1.414L12 14.414l2.274 2.274a1 1 0 0 0 1.414-1.414L13.414 13l2.274-2.274Z" })));
});
